export default "__VITE_ASSET__DdITDVA8__"